import logo from '../../assets/50px_logo.svg'
export const PurposelyLogo = () => (
  <img src={logo} alt={'logo'} />
)
